import { Typography, Button, Stack } from "@mui/material"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./ISError.module.css"

type ISErrorProps = {
    title?: string,
    error?: string,
}

export const ISError = (props: ISErrorProps) =>{
    const {t} = useTranslation("others")

    return <>
        <Stack direction='column' alignItems='center'>
            <Typography className={styles.title} variant="h4">{props.title ? props.title : t("errorOcurred")}</Typography>
            <Typography className={styles.text} variant="h6">{props.error ? props.error :  t("errorOcurred")}</Typography>
            <Link to="/login">
                <Button variant="contained" color="success" >{t("home")}</Button>
            </Link>
        </Stack>
    </>
}